export const LineChartImg = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 38C7.5 38 15.0129 35.0799 23.5 32C32.0405 28.9007 32.4703 36.0048 41.5 35C46.2258 34.4741 47.1779 27.4822 51.5 25.5C54.411 24.165 56.5 19 56.5 19"
      stroke="#DFECFF"
    />
    <path
      d="M7 44.5019C7 44.5019 11.5 34.9982 19.5 28.5003C26.5523 22.7721 31.4703 29.5067 40.5 28.5019C45.2258 27.976 47.6779 34.4841 52 32.5019C54.911 31.1669 57.5 30.5035 57.5 30.5035"
      stroke="#1E78FF"
    />
  </svg>
);
